import { Fetcher } from '../../Fetcher';

import { parseBonusCampaign } from './parsers';
import type { BonusCampaign, BonusCampaigns } from './types/bonus';
import type {
  AckBonusParams,
  BonusApiStatusDetails,
  BonusHistoryApiParams,
  ClaimBonusParams,
  GetBonusCampaigns,
  GetBonusTransactionHistory,
  ExpiryBonusParams,
  BonusApiDefaultParams,
} from './types/bonusApi';
import { BonusApiStatus } from './types/constants';

export const fetchBonusCampaigns = ({ tableId, jwt, env }: BonusApiDefaultParams): Promise<BonusCampaigns> => {
  return Fetcher.fetch<GetBonusCampaigns>(`${env}/v1/campaign/eligible/${tableId}`, {
    headers: { Authorization: `Bearer ${jwt}` },
    force: true,
  }).then((res) => {
    return {
      activeBonusCampaign: res.eligible[0] ? parseBonusCampaign(res.eligible[0]) : null,
      wageredCampaigns: res.wagered.map(parseBonusCampaign),
      cancelledCampaigns: res.cancelled.map(parseBonusCampaign),
    };
  });
};

export const fetchBonusHistory = ({
  tableId,
  jwt,
  page,
  size,
  env,
}: BonusHistoryApiParams): Promise<GetBonusTransactionHistory> => {
  return Fetcher.fetch<GetBonusTransactionHistory>(`${env}/v1/bonus/history/${tableId}`, {
    headers: { Authorization: `Bearer ${jwt}` },
    params: { size, page },
    force: true,
  });
};

export const postClaimBonus = ({ tableId, jwt, code, env, bonusId }: ClaimBonusParams): Promise<BonusCampaign> => {
  return Fetcher.fetch<BonusApiStatusDetails>(`${env}/v1/bonus/claimBonus/${code}/${tableId}`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${jwt}`,
      'Content-Type': 'application/json',
    },
    body: {
      bonusId,
    },
  }).then((res) => {
    if (res.status === BonusApiStatus.Success) {
      return parseBonusCampaign(res.bonus);
    }
    throw new Error(`${res.errorCode}:${res.message}`);
  });
};

export const postAckBonus = ({ jwt, env, bonusId, ackType }: AckBonusParams): Promise<BonusCampaign> => {
  return Fetcher.fetch<BonusApiStatusDetails>(`${env}/v1/ack/${bonusId}`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${jwt}`,
      'Content-Type': 'application/json',
    },
    body: {
      ackType,
    },
  }).then((res) => {
    if (res.status === BonusApiStatus.Success) {
      return parseBonusCampaign(res.bonus);
    }
    throw new Error(`${res.errorCode}:${res.message}`);
  });
};

export const postBonusExpiry = ({ jwt, env, bonusId }: ExpiryBonusParams): Promise<boolean> => {
  return Fetcher.fetch<BonusApiStatusDetails>(`${env}/v1/bonus/timerEnd/${bonusId}`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${jwt}`,
      'Content-Type': 'application/json',
    },
  }).then((res) => {
    if (res.status === BonusApiStatus.Success) {
      return true;
    }
    throw new Error(`${res.errorCode}:${res.message}`);
  });
};
